<template>
    <div>
        <!--
            Item has submenu
        -->
        <v-list-group
            v-if="item.hasChildren"
            :key="item.id"
            v-model="itemActive"
            color="primaryBackground"
            :data-level="item.level"
        >
            <template #activator>
                <v-list-item-icon>
                    <v-icon color="primaryBackground">{{ item.icon }}</v-icon>
                </v-list-item-icon>
                <v-list-item-title>
                    {{ item.name }}
                    <v-progress-circular
                        v-if="item.loading"
                        class="align-self-start"
                        :size="14"
                        :width="2"
                        color="primaryBackground"
                        indeterminate
                    />
                    <v-icon v-else small dense color="primaryBackground">
                        {{ getIcon('expand') }}
                    </v-icon>
                </v-list-item-title>
            </template>
            <div class="app-nav-menu__item-group" :data-level="item.level + 1">
                <template v-for="subitem in item.children">
                    <app-nav-menu-item
                        :key="subitem.id"
                        v-test-id="`platform-subnav-${_.snakeCase(item.name)}-${_.snakeCase(subitem.name)}`"
                        :item="subitem"
                        :on-hide-submenu="onHideSubmenu"
                        @item-click="onItemClick"
                    />
                </template>
            </div>
        </v-list-group>
        <!--
            Item has no submenu
        -->
        <v-list-item
            v-else
            :key="item.name"
            :color="item.colour ? item.colour : 'primaryBackground'"
            :to="item.path"
            :exact-path="!!item.path"
            :disabled="item.disabled"
            @click="onSingleItemClick(item)"
        >
            <v-list-item-icon>
                <v-icon :color="item.colour ? item.colour : 'primaryBackground'">{{ item.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>
                {{ item.name }}
            </v-list-item-title>
        </v-list-item>
    </div>
</template>

<script>
export default {
    name: 'AppNavMenuItem',
    props: {
        item: {
            type: Object,
            required: true
        },
        onHideSubmenu: {
            type: Function,
            required: true
        }
    },
    computed: {
        itemActive: {
            get() {
                return this.item.active;
            },
            set(value) {
                if (!this.item.disabled) {
                    this.$emit('item-click', this.item, value);
                }
            }
        }
    },
    methods: {
        onItemClick(item) {
            if (!item.disabled) {
                this.$emit('item-click', item, !item.active);
            }
        },
        onSingleItemClick(item) {
            this.onHideSubmenu();

            if (!item.disabled) {
                if (item.href) {
                    window.open(item.href);
                }
                this.$emit('item-click', item, !item.active);
            }
        }
    }
};
</script>
